export default {
	Steam(item){
		let controller = []
		controller.push({t:'Login',c:'green',a:this.doLoginSteam, i:'mdi-login'});
		controller.push({t:'Get Confirms',c:'blue',a:this.doOpenListConfirm, i:'mdi-open-in-new'});
		controller.push({t:'List Items',c:'blue lighten-2',a:this.doOpenListItems, i:'mdi-open-in-new'});
		return controller
	}
}